<template>
    <div class="card card-info" v-else>
        <div class="card-header">
            <h3 class="card-title" style="width: 100%">
                <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
            </h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table id="table" class="table table-bordered table-sm text-sm" width="100%">
                            <thead class="bg-info">
                                <tr>
                                    <th>Job Campaign</th>
                                    <th>Job Title</th>
                                    <th>Description</th>
                                    <th>Last Date</th>
                                    <th width="30px">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, ind) in allJobOfferingRecord">
                                    <td>{{item.JobCampaign}}</td>
                                    <td>{{item.JobTitle}}</td>
                                    <td><div v-html="item.Description"></div></td>
                                    <td>{{item.LastDate}}</td>
                                    <td>
                                        <button class="btn btn-sm btn-info" v-on:click="edit(item.JobOfferingID)">Edit</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="mdlPatientRecord">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header bg-primary">
                        <h4 class="modal-title">Date Extend</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Effective To *</label>
                                    <input v-model="merit.EffectiveTo" type="date" class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer ">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                        <button type="button" class="btn btn-success" v-on:click="updateDate()">
                            Update
                        </button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>

    </div>
</template>
<script>const axios = require('axios').default;
    export default ({
        data() {
            return {
                allJobOfferingRecord: [],
                merit: { EffectiveTo: '', MeritListID: '' },

            }
        },
        created: function () {
            this.pageLoad();
        },
        updated: function () {
            $('#table').DataTable();
        },
        methods: {
            pageLoad() {
                var vm = this;
                startReq();
                axios.get("/ApplicantsApi/JobOfferingRecord")
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            vm.allJobOfferingRecord = res.data.lst;
                        }
                        else {
                            toastr.error(res.data.msg);
                        }
                    })
                    .catch(function (error) {

                    });
            },
            AddNew() {
                window.location.href = "../Jobs/JobOffering";
            },
            edit(ID) {
                var vm = this;
                axios.post("/ApplicantsApi/editJobOffering?ID=" + ID)
                    .then(function (res) {
                        if (res.data.status) {
                            window.open('../Jobs/JobOffering', '_blank');
                        }
                        else {
                            toastr.error(res.data.msg);
                        }
                    })
                    .catch(function (error) {

                    });
            },

        }
    })</script>



// WEBPACK FOOTER //
// src/components/jobOfferingIndex.vue